import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const Container = styled(NavLink)`
  &.active {
    color: ${({ theme }) => theme.prevColors.streamsBlue};
  }
`;
